
  <div class="mb-4">
    <!--
    <label class="form-label text-muted small fw-bold text-uppercase tracking-wider mb-1" style="font-size: 0.75rem;">
      Buscar por grupo
    </label>
    -->
    <div class="input-group">
      <span class="input-group-text bg-white text-muted">
        <i class="fa fa-users"></i>
      </span>
      <app-groups 
        (idGroup)="onPick($event)" 
        class="form-control p-0">
      </app-groups>
    </div>
  </div>
